import { useEffect, useLayoutEffect, useRef } from 'react';

export function useRaidChatHistoryScroll(scrollRef, room) {
  const anchorRef = useRef(null);
  const interactionRef = useRef(false);
  const previousModeRef = useRef(false);
  useEffect(() => {
    const node = scrollRef.current;
    if (!node) return;
    const interact = () => { interactionRef.current = true; };
    const latest = () => { interactionRef.current = false; anchorRef.current = null; room.showLatestMessages(); };
    node.addEventListener('wheel', interact, { passive: true });
    node.addEventListener('touchstart', interact, { passive: true });
    node.addEventListener('keydown', interact);
    node.addEventListener('raid-chat-latest', latest);
    return () => {
      node.removeEventListener('wheel', interact); node.removeEventListener('touchstart', interact);
      node.removeEventListener('keydown', interact); node.removeEventListener('raid-chat-latest', latest);
    };
  }, [scrollRef, room.showLatestMessages]);
  useLayoutEffect(() => {
    const node = scrollRef.current, anchor = anchorRef.current;
    if (previousModeRef.current && !room.historyMode && node) {
      node.scrollTop = node.scrollHeight;
      anchorRef.current = null;
      previousModeRef.current = false;
      return;
    }
    previousModeRef.current = room.historyMode;
    if (!node || !anchor || room.historyPageVersion === anchor.version) return;
    const entry = [...node.querySelectorAll('[data-message-id]')].find(item => item.dataset.messageId === anchor.id);
    if (entry) node.scrollTop += entry.getBoundingClientRect().top - anchor.top;
    anchorRef.current = null;
    interactionRef.current = false;
  }, [room.messages, room.historyMode, room.historyPageVersion]);
  const loadOlder = () => {
    const node = scrollRef.current;
    if (!node || room.historyLoading || !room.hasOlderMessages) return;
    const top = node.getBoundingClientRect().top;
    const entry = [...node.querySelectorAll('[data-message-id]')].find(item => item.getBoundingClientRect().bottom > top);
    anchorRef.current = entry ? { id: entry.dataset.messageId, top: entry.getBoundingClientRect().top, version: room.historyPageVersion } : null;
    room.loadOlderMessages();
  };
  return { loadOlder, onHistoryScroll: () => {
    const node = scrollRef.current;
    if (!interactionRef.current || !node) return;
    if (room.historyMode && node.scrollHeight - node.scrollTop - node.clientHeight < 48) {
      interactionRef.current = false;
      anchorRef.current = null;
      room.showLatestMessages();
      return;
    }
    if (node.scrollTop < 48 && !room.historyError) loadOlder();
  } };
}
